module.exports = __webpack_public_path__ + "static_pc/img/team4.e5f4374c.png";